"use strict";

$(document).ready(function () {
  //JS for Securiti Cookie in footer
  var cookieLink = document.getElementsByClassName("cmp-revoke-consent");
  if (cookieLink.length > 0) {
    cookieLink[0].setAttribute("href", "#");
    cookieLink[0].addEventListener("click", function (event) {
      event.preventDefault();
    });
  }
  var $stickyfooter = $(".sticky-footer");
  if (!$stickyfooter.length) {
    return;
  }
  var btn = $stickyfooter.find('.btn');
  var transitioning = false;
  if (btn.length) {
    btn.on('click', function () {
      transitioning = true;
      $stickyfooter.stop().slideToggle(400, function () {
        $stickyfooter.addClass('is-hidden');
        transitioning = false;
      });
    });
  }
  var mywindow = $(window);
  var mypos = mywindow.scrollTop();
  var up = false;
  var newscroll;
  mywindow.scroll(function () {
    if (!transitioning) {
      newscroll = mywindow.scrollTop();
      if (newscroll > mypos && !up || newscroll < mypos && up) {
        $stickyfooter.stop().slideToggle();
        up = !up;
      }
      mypos = newscroll;
    }
  });
});